module.exports = __webpack_public_path__ + "img/dinjinguanli.2a98f04f.png";